module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Johnny-English-Strikes-Again.1aebcce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Johnny-English-Strikes-Again.jpg
// module id = KS1u
// module chunks = 0